<template>
  <div class="join-page">
    <div class="join-main">
      <!-- 背景图 -->
      <img class="join-bg" src="../assets/images/about/about-1-company.png" alt="" />
      <div class="join-content">
        <button class="join-back-btn" @click="goBack">{{ $t('join.back') }}</button>
        <h1 class="join-title">{{ $t('join.hotJobs') }}</h1>
        <div class="join-list">
          <div v-for="job in jobs" :key="job.id" class="job-card">
            <span class="job-name">{{ $t('join.jobs.' + job.id) }}</span>
            <button class="job-apply-btn" @click="apply(job.id)">{{ $t('join.applyNow') }}</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'JoinPage',
  components: { Footer },
  data() {
    return {
      // 岗位 id 对应 i18n 文案
      jobs: [
        { id: 'register' },
        { id: 'backend' },
        { id: 'tester' },
        { id: 'sales' },
        { id: 'trade' },
        { id: 'regSpecialist' },
        { id: 'embedded' }
      ]
    }
  },
  methods: {
    // 跳转投递页并带上岗位 id
    apply(id) {
      this.$router.push('/join/apply?job=' + id)
    },
    // 返回关于我们
    goBack() {
      this.$router.push('/about')
    }
  },
  watch: {
    // 英文版无此页，跳回关于我们
    '$i18n.locale'(val) {
      if (val === 'en') {
        this.$router.replace('/about')
      }
    }
  }
}
</script>

<style scoped>
.join-page {
  padding-top: 80px;
}

/* 页面主体 */
.join-main {
  position: relative;
  min-height: calc(100vh - 80px);
}

.join-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 内容区 */
.join-content {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 50px 40px 140px;
}

.join-back-btn {
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease;
}

.join-back-btn:hover {
  opacity: 0.7;
}

.join-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 20px 0;
  position: relative;
}

/* 标题下划线 */
.join-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 11.8%;
  height: 2px;
  background: #FFFFFF;
}

/* 英文版标题 */
:lang(en) .join-title {
  font-size: 42px;
}

/* 岗位卡片 */
.job-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(240, 240, 240, 0.5);
  border-radius: 10px;
  height: 80px;
  padding: 0 44px;
  margin-bottom: 16px;
}

.job-name {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
}

/* 投递按钮 */
.job-apply-btn {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 12px 36px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.job-apply-btn:hover {
  background: #00C4D4;
}

/* 移动端 */
@media (max-width: 1024px) {
  .join-page {
    padding-top: 0;
  }

  .join-main {
    min-height: 100vh;
  }

  .join-content {
    padding: 14vh 6% 20vh;
  }

  .join-back-btn {
    font-size: 4.27vw;
    transform: translateY(-3vh);
  }

  .join-title {
    font-size: 8vw;
    margin: 0 0 3vh 0;
  }

  .join-title::after {
    bottom: -1vh;
    height: 0.4vh;
    width: 24vw;
  }

  :lang(en) .join-title {
    font-size: 9vw;
  }

  .job-card {
    height: 9vh;
    padding: 0 6%;
    margin-bottom: 2vh;
    border-radius: 2vw;
  }

  .job-name {
    font-size: 5vw;
  }

  :lang(en) .job-name {
    font-size: 4.5vw;
  }

  .job-apply-btn {
    padding: 1.5vh 5vw;
    font-size: 4vw;
    border-radius: 2vw;
  }

  :lang(en) .job-apply-btn {
    font-size: 3.5vw;
  }
}
</style>
